import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import {
  getBrand,
  applyBrandToDocument
} from "./branding";

import "./index.css";
import App from "./App.jsx";
import Recover from "./components/Recover.jsx";
import Login from "./components/Login.jsx";
import CompletedExam from "./components/CompletedExam.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { ExamLoadingBoundary } from "./components/ExamLoader.jsx";

const brand = getBrand();

applyBrandToDocument(brand);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <ExamLoadingBoundary>
      <Routes>
        {/* Login */}
        <Route path="/" element={<Login />} />
        <Route path="/recover" element={<Recover/>} />
        <Route path="/login" element={<Login />} />
        <Route path="/exams" element={<Login />} />

        {/* PRACTICE — PUBLIC */}
        <Route
          path="/practice/:examId"
          element={<App practiceMode />}
        />

        {/* CHAIR - PRIVATE */}
        <Route
          path="/chair/private/:examId"
          element={<App chairMode />}
        />

        {/* REAL EXAM — PROTECTED */}
        <Route
          path="/exam/:examId"
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }
        />

        {/* DEV MODE */}
        <Route
          path="/dev/:examId"
          element={
            <App devMode/>
          }
        />

        {/* REVIEW — PUBLIC */}
        <Route
          path="/submissions/:submissionId"
          element={<CompletedExam />}
        />

        <Route path="*" element={<div>Not found</div>} />
      </Routes>
      </ExamLoadingBoundary>

    </BrowserRouter>
  </StrictMode>
);

